import Main from './Main.vue'
import {default as arrematantes} from './arematantes/routes'
import {default as comitentes} from './comitentes/routes'
import {default as contatos} from './contatos/routes'
import {default as documentos} from './documentos/routes'
import {default as leiloes} from './leiloes/routes'
import {default as leiloeiro} from './leiloeiro/routes'
import {default as banners} from './banners/routes'
import {default as editar} from './utilitarios/routes'
import {default as pregao} from './pregao/routes'
import {default as pregaoComitente} from './pregao-comitente/routes'
import {default as pregaoLeiloeiro} from './pregao-leiloeiro/routes'
import {default as pregaoLeiloeiroPatio} from './pregao-leiloeiro-patio/routes'
import {default as pregaoLance} from './pregao-lance/routes'
import {default as pregaoLance2} from './pregao-lance2/routes'
import {default as pregaoLanceCronometro} from './pregao-lance-cronometro/routes'
import {default as usuarios} from './usuarios/routes'
import {default as acls} from './acl/routes'
import {default as eventos} from './eventos/routes'
import {default as popups} from './popup/routes'
import {default as apresentacaoLotes} from './apresentacao-lotes/routes'
import {default as relatoriosBasicos} from './relatorios-basicos/routes'
import {default as trabalheConosco} from './trabalhe-conosco/routes'
import {default as grvs} from './grvs/routes'
import {default as preretirada} from './preretirada/routes'
import {default as retirada} from './retirada/routes'
import {default as gmaps} from './mapa/routes'
import {default as edital} from './edital/routes'
import {default as relatoriosGerenciais} from './relatorios-gerenciais/routes'
import {default as transferenciaPatio} from './transferencia-patio/routes'
import {default as localizacaoVeiculo} from './localizacao-veiculo/routes'
import {default as logs} from './logs/routes'
import {default as tasks} from './tasks/routes'
import {default as historicoAlteracoes} from './historico-alteracoes/routes'

export default [{
  path: '/website',
  name: 'website',
  component: Main,
  children: [
    ...arrematantes,
    ...comitentes,
    ...leiloes,
    ...contatos,
    ...leiloeiro,
    ...documentos,
    ...banners,
    ...editar,
    ...pregao,
    ...pregaoComitente,
    ...pregaoLeiloeiro,
    ...pregaoLeiloeiroPatio,
    ...usuarios,
    ...acls,
    ...eventos,
    ...pregaoLance,
    ...pregaoLance2,
    ...pregaoLanceCronometro,
    ...popups,
    ...apresentacaoLotes,
    ...relatoriosBasicos,
    ...trabalheConosco,
    ...grvs,
    ...preretirada,
    ...retirada,
    ...gmaps,
    ...edital,
    ...relatoriosGerenciais,
    ...localizacaoVeiculo,
    ...transferenciaPatio,
    ...logs,
    ...tasks,
    ...historicoAlteracoes
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/routes.js